import { Component, OnInit } from '@angular/core';

import { AppMessageService } from '../../services/app-message.service';

import { NgMessage } from "../ng-message";
import { StatusTypes } from '../status-types';

import { AppContext } from "../../app.context";
import { BaseComponent } from "../../components/base/base.component";
import { AppInsightsService } from "../../services/app-insights.service";

import { MessageCodes } from "../message-codes";
import { NewsAnnouncementTitles } from '../news-announcement-titles';

import { NewsAnnouncementsService } from './news-announcements.service';
import { NewsAnnouncement, NewsAnnouncementIds } from './news-announcements.model';

@Component({
  selector: 'app-news-announcements',
  templateUrl: './news-announcements.component.html',
  styleUrls: ['./news-announcements.component.scss'],
  providers: [NewsAnnouncementsService]
})
export class NewsAnnouncementsComponent extends BaseComponent implements OnInit {
  models: NewsAnnouncement[];
  selectedModel: NewsAnnouncement;

  ids: NewsAnnouncementIds;
  titles: NewsAnnouncementTitles;

  unknownErrorMessage: NgMessage;

  constructor(
    readonly appContext: AppContext,
    readonly appMessageService: AppMessageService,
    readonly appInsightsService: AppInsightsService,
    readonly newsAnnouncementsService: NewsAnnouncementsService
  ) {
    super(appContext, appInsightsService);

    this.ids = new NewsAnnouncementIds();
    this.titles = new NewsAnnouncementTitles();
    this.unknownErrorMessage = appContext.messages[MessageCodes.UnknownError];
  }

  ngOnInit() {
    this.newsAnnouncementsService.fetch().subscribe(ngResponse => {
      if (!ngResponse) {
        this.appMessageService.add({
          severity: this.unknownErrorMessage.severityLevel.toLocaleString(),
          summary: this.unknownErrorMessage.text
        });
      } else if (ngResponse.status === StatusTypes.Success) {
        ngResponse.response.forEach(
          model => {
            model.baseId = this.ids[model.category];
            model.title = this.titles[model.category];
          });
        this.models = ngResponse.response;
      } else {
        this.appMessageService.add({
          severity: ngResponse.error.severityLevel.toLocaleString(),
          summary: ngResponse.error.failureReason
        });
      }
    },
    err => {
      this.appMessageService.add({
        severity: this.unknownErrorMessage.severityLevel.toLocaleString(),
        summary: this.unknownErrorMessage.text
      });
    });
  }
}
